import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
// import custom StatusBadge and Toggle if you have them, or use placeholders
import StatusToggle from '../ui/StatusToggle'

// Custom StatusBadge component
const StatusBadge = ({ status }) => {
  if (status === 'None') {
    return (
      <div className="justify-center border-r-[color:var(--Stock,#F0F0F0)] flex flex-col text-xs text-[#E90004] font-medium whitespace-nowrap text-center leading-none w-[199px] px-5 py-2 border-r border-solid">
        <div className="bg-[rgba(233,0,4,0.10)] flex flex-col items-center justify-center px-2 py-1.5 rounded-[20px]">
          <div className="flex gap-1">
            <span className="flex items-center">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="7"
                  cy="7"
                  r="6.5"
                  fill="#fff"
                  stroke="#E90004"
                  strokeWidth="1"
                />
                <path
                  d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5"
                  stroke="#E90004"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </span>
            <div>Not Assigned</div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="justify-center border-r-[color:var(--Stock,#F0F0F0)] flex flex-col text-xs text-[rgba(4,146,185,1)] font-medium whitespace-nowrap text-center leading-none w-[199px] px-5 py-2 border-r border-solid">
      <div className="bg-[rgba(4,146,185,0.1)] flex flex-col items-center justify-center px-2 py-1.5 rounded-[20px]">
        <div className="flex gap-1">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/fa9cebe651f1f5ccad3b469ace21dc73ab8498b0?placeholderIfAbsent=true"
            className="aspect-[1] object-contain w-3.5 shrink-0"
            alt="Status icon"
          />
          <div>{status}</div>
        </div>
      </div>
    </div>
  )
}

function StudentActTestList() {
  const [data, setData] = useState([])
  const [tests, settests] = useState([])
  const { id } = useParams()
  const navigate = useNavigate()
  // Modal state for unassign
  const [unassignModalOpen, setUnassignModalOpen] = useState(false)
  const [testToUnassign, setTestToUnassign] = useState(null)

  useEffect(() => {
    gettests()
  }, [])

  useEffect(() => {
    if (id) {
      getSingleStudent(id)
    }
  }, [id])

  const getSingleStudent = async (id) => {
    await axios.get(`${process.env.REACT_APP_BASE_URL}edit/${id}`)
  }

  const unassignTest = async (testId) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}unassignactstest/${testId}/${id}`
    )
    toast.success(response.data)
    // Optionally update state here instead of reload
    window.location.reload(true)
  }

  const gettests = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getacttests/${id}`
    )
    if (response.status === 200) {
      setData(response.data)
    }
  }

  const checkStudent = (item, e) => {
    let index = tests.indexOf(item)
    let testsTemp = tests.slice()
    if (index > -1) {
      testsTemp.splice(index, 1)
    } else {
      testsTemp.push(item)
    }
    settests(testsTemp)
  }

  const handleSubmitAssign = async (e) => {
    e.preventDefault()
    if (tests.length === 0) {
      toast.error('Please Choose ACT Test')
    } else {
      let dataSend = {
        student_id: id,
        tests: tests,
      }
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BASE_URL}assignateststudent`,
          dataSend,
          { withCredentials: true }
        )
        if (data) {
          toast.success('ACT Test Assigned Successfully.')
          window.location.reload(true)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  // Map data to reference structure for easier rendering
  const mappedData = data.map((item, index) => ({
    id: item._id,
    sNo: String(index + 1).padStart(2, '0'),
    testCode: item.test_code,
    testName: item.test_title,
    status: item.status === 1 || item.bstatus === 1 ? 'Assigned' : 'None',
    isActive: item.status === 1 || item.bstatus === 1,
    isSelected:
      item.status === 1 || item.bstatus === 1 || tests.includes(item._id),
    start_date: item.start_date,
    end_date: item.end_date,
    raw: item,
  }))

  return (
    <div className="w-full mt-2.5 max-md:max-w-full">
      <div className="justify-between items-center border border-[color:var(--Stock,#F0F0F0)] flex w-full gap-[40px_100px] font-medium leading-[1.2] flex-wrap bg-white px-5 py-3.5 rounded-[10px_10px_0px_0px] border-solid max-md:max-w-full">
        <div className="text-[#030303] text-lg self-stretch my-auto">
          ACT Tests List
        </div>
        <button
          className="justify-center items-stretch flex flex-col text-xs text-white text-center w-[100px] bg-[#DE3C7D] my-auto p-2.5 rounded-md hover:bg-[#c72c6a] transition-colors font-medium"
          type="submit"
          onClick={handleSubmitAssign}
        >
          <div className="flex w-full gap-1">
            <div className="text-white">Assign Tests</div>
          </div>
        </button>
      </div>
      {/* Table Header */}
      <div className="flex w-full bg-neutral-50 border-b border-l border-r border-[#F0F0F0]">
        <div className="w-20 flex-none px-4 py-3.5 border-r border-[#F0F0F0]"></div>{' '}
        {/* Checkbox */}
        <div className="w-20 flex-none px-4 py-3.5 border-r border-[#F0F0F0] text-center">
          S.No
        </div>
        <div className="w-40 flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          Test Code
        </div>
        <div className="w-[32rem] flex-none px-4 py-3.5 border-r border-[#F0F0F0]">
          Test Name
        </div>
        <div className="w-60 flex-none px-4 py-3.5 border-r border-[#F0F0F0] text-center">
          Status
        </div>
        <div className="w-20 flex-none px-4 py-3.5 text-center">Action</div>
      </div>
      {/* Table Rows */}
      {mappedData.length > 0 ? (
        mappedData.map((item, index) => (
          <div
            key={item.id}
            className={`flex w-full border-b border-l border-r border-[#F0F0F0] bg-white ${
              index === mappedData.length - 1 ? 'rounded-b-[10px]' : ''
            }`}
          >
            <div className="w-20 flex-none px-4 py-2 border-r border-[#F0F0F0] flex items-center justify-center">
              <label className="cursor-pointer">
                <input
                  type="checkbox"
                  checked={item.isSelected}
                  onChange={() => checkStudent(item.id)}
                  className="sr-only"
                />
                <span className="inline-block w-4 h-4">
                  {item.isSelected ? (
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/d84e059b57274e6aae99b9cca7cfff8b/ef7fcf665d69a24f338a53eba4618a706e0d31d1?placeholderIfAbsent=true"
                      className="w-full h-full object-contain"
                      alt="Selected"
                    />
                  ) : (
                    <div className="w-full h-full border border-[color:var(--Text,#535862)] rounded-[3px] border-solid" />
                  )}
                </span>
              </label>
            </div>
            <div className="w-20 flex-none px-4 py-2 border-r border-[#F0F0F0] text-center">
              {item.sNo}
            </div>
            <div className="w-40 flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.testCode}
            </div>
            <div className="w-[32rem] flex-none px-4 py-2 border-r border-[#F0F0F0]">
              {item.testName}
            </div>
            <div className="w-60 flex-none px-4 py-2 border-r border-[#F0F0F0] flex items-center justify-center">
              <StatusBadge status={item.status} />
            </div>
            <div className="w-20 flex-none px-4 py-2 flex items-center justify-center">
              <StatusToggle
                status={item.isActive}
                onChange={
                  item.isActive
                    ? () => {
                        setTestToUnassign(item.id)
                        setUnassignModalOpen(true)
                      }
                    : undefined
                }
                disabled={!item.isActive}
              />
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-8 text-[#535862] text-sm border-x border-b border-[color:var(--Stock,#F0F0F0)] bg-white rounded-b-[10px]">
          No Data Available
        </div>
      )}
      {/* Custom Unassign Modal */}
      {unassignModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 w-full max-w-md shadow-lg">
            <h2 className="text-lg font-bold mb-4 text-center">
              Unassign Test
            </h2>
            <p className="mb-6 text-center text-[#535862]">
              Are you sure you want to unassign this test?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="px-6 py-2 rounded bg-[#DE3C7D] text-white font-semibold hover:bg-[#c72c6a] transition"
                onClick={async () => {
                  await unassignTest(testToUnassign)
                  setUnassignModalOpen(false)
                  setTestToUnassign(null)
                }}
              >
                Yes, Unassign
              </button>
              <button
                className="px-6 py-2 rounded bg-gray-200 text-[#535862] font-semibold hover:bg-gray-300 transition"
                onClick={() => {
                  setUnassignModalOpen(false)
                  setTestToUnassign(null)
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default StudentActTestList
